<template src="./verticals-list.component.html"></template>
<style scoped src="./verticals-list.component.css"></style>
<script lang="ts">
import Vue from 'vue';
import axios from 'axios';
import debounce from 'debounce';
import Sidebar from '@/components/sidebar/sidebar.component.vue';
import api from '@/api';
import {toasted} from '@/plugins/toasted';
import {Filter, getErrorMessage, noop, Pagination} from '@/helpers';
import {Vertical} from '@/models';

export default Vue.extend({
  data() {
    return {
      msg: 'Verticals List',
      ac: null as AbortController | null,
      verticals: [] as Vertical[],
      showLoading: false,
      filter: new Filter({
        search: '',
      }),
      pagination: new Pagination({
        perPage: 50,
      }),
      // @ts-ignore
      debouncedSearch: debounce(this.getVerticals, 500),
    };
  },
  components: {
    Sidebar,
  },
  mounted() {
    document.body.classList.add(
      'min-w-site',
      'bg-40',
      'text-90',
      'font-medium',
      'min-h-full',
    );
  },
  destroyed() {
    document.body.classList.add(
      'min-w-site',
      'bg-40',
      'text-90',
      'font-medium',
      'min-h-full',
    );
  },
  watch: {
    '$route.query': {
      async handler(query) {
        this.filter.loadFromQuery(query);
        this.pagination.loadFromQuery(query);
        await this.getVerticals();
      },
      immediate: true,
    },
    'filter.search'() {
      this.debouncedSearch();
    },
  },
  methods: {
    refreshVerticalsNoFilters() {
      this.filter.reset();
      this.updateQueryParams({page: 1});
    },
    refreshVerticalsWithFilters() {
      this.updateQueryParams({...this.filter, page: 1});
    },
    updatePage(page: number) {
      this.updateQueryParams({...this.filter, page});
    },
    getSearchParams() {
      const searchParams = new URLSearchParams();
      this.filter.buildSearchParams(searchParams);
      this.pagination.buildSearchParams(searchParams);
      return searchParams;
    },
    async getVerticals() {
      try {
        this.showLoading = true;
        const searchParams = this.getSearchParams();
        this.ac?.abort();
        this.ac = new AbortController();
        const [rows, count] = await Promise.all([api.execute(
          'get',
          `/verticals?${searchParams.toString()}`,
          null,
          null,
          this.ac.signal,
        ), api.execute(
          'get',
          `/verticals/count?${this.filter.buildSearchParams(new URLSearchParams()).toString()}`,
          null,
          null,
          this.ac.signal,
        )]) as [Vertical[], number];
        this.verticals = rows;
        this.pagination.total = count;
      } catch (e) {
        console.error(e);
        if (!axios.isCancel(e)) {
          toasted.showErrorMessage(getErrorMessage(e));
        }
      } finally {
        this.showLoading = false;
      }
    },
    async deleteVertical(id: number) {
      try {
        await api.execute('delete', `/verticals/${id}`);
        await this.getVerticals();
      } catch (e) {
        console.error(e);
        if (!axios.isCancel(e)) {
          toasted.showErrorMessage(getErrorMessage(e));
        }
      }
    },
    updateQueryParams(query: {[key: string]: any}) {
      this.$router.push({query}).catch(noop);
    },
  },
});
</script>
